type LoadingScreenProps = {
  compact?: boolean
}

const LoadingScreen = ({compact = false}: LoadingScreenProps) => {
  return (
    <div
      className={`ui-loading-screen${compact ? ' ui-loading-screen--compact' : ''}`}
      role='status'
      aria-live='polite'
    >
      <div className='ui-loading-card'>
        <div className='ui-brand-mark ui-loading-mark' aria-hidden='true'>
          PO
        </div>
        <div className='ui-loading-copy'>
          <strong>POLab</strong>
          <span>Подготавливаем рабочее пространство</span>
        </div>
        <span className='ui-loading-spinner' aria-hidden='true' />
      </div>
      <span className='visually-hidden'>Загрузка приложения</span>
    </div>
  )
}

export {LoadingScreen}
